<article class="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
  <p class="text-sm font-medium tracking-wide text-tan uppercase">We're here to help</p>
  <h1 class="mt-2 font-display text-4xl font-semibold text-ink italic sm:text-5xl">Contact us</h1>
  <p class="mt-6 text-base leading-relaxed text-ink/80">
    Questions about a listing, an order, or selling on Galopa? Send us a note and we'll get back to
    you as soon as we can.
  </p>

  @if (submitted()) {
    <div class="mt-12 rounded-2xl border border-line bg-creamdark/40 px-6 py-10 text-center">
      <p class="font-display text-2xl font-semibold text-ink italic">Thanks for reaching out</p>
      <p class="mt-3 text-sm leading-relaxed text-ink/70">
        We've received your message and will reply to
        <strong class="text-ink">{{ form.getRawValue().email }}</strong> shortly.
      </p>
      <p class="mt-8 text-sm text-ink/70">
        <a routerLink="/help" class="font-medium text-forest hover:underline"
          >Browse Help &amp; FAQ</a
        >
        <span class="mx-2 text-ink/30">·</span>
        <a routerLink="/shop" class="font-medium text-forest hover:underline">Back to shop</a>
      </p>
    </div>
  } @else {
    <form class="mt-10 flex max-w-xl flex-col gap-5" [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <label for="contact-name" class="block text-sm font-medium text-ink">Name</label>
        <input
          id="contact-name"
          type="text"
          formControlName="name"
          autocomplete="name"
          class="mt-1.5 w-full rounded-xl border border-line bg-white px-3 py-2.5 text-sm text-ink shadow-sm transition placeholder:text-ink/35 focus:border-forest focus:ring-2 focus:ring-forest/15 focus:outline-none"
          placeholder="Your name"
        />
      </div>

      <div>
        <label for="contact-email" class="block text-sm font-medium text-ink">Email</label>
        <input
          id="contact-email"
          type="email"
          formControlName="email"
          autocomplete="email"
          class="mt-1.5 w-full rounded-xl border border-line bg-white px-3 py-2.5 text-sm text-ink shadow-sm transition placeholder:text-ink/35 focus:border-forest focus:ring-2 focus:ring-forest/15 focus:outline-none"
          placeholder="you@example.com"
        />
      </div>

      <div>
        <label for="contact-message" class="block text-sm font-medium text-ink">Message</label>
        <textarea
          id="contact-message"
          formControlName="message"
          rows="6"
          class="mt-1.5 w-full rounded-xl border border-line bg-white px-3 py-2.5 text-sm text-ink shadow-sm transition placeholder:text-ink/35 focus:border-forest focus:ring-2 focus:ring-forest/15 focus:outline-none"
          placeholder="How can we help?"
        ></textarea>
      </div>

      @if (errorMessage()) {
        <p class="flex items-center gap-2 text-sm text-rose">
          <app-icon name="alert" svgClass="h-4 w-4 shrink-0" />
          {{ errorMessage() }}
        </p>
      }

      <button
        type="submit"
        class="cursor-pointer mt-1 inline-flex items-center justify-center gap-2 self-start rounded-full bg-forest px-6 py-3 text-sm font-medium text-cream transition hover:bg-forestdark disabled:opacity-60"
        [disabled]="submitting()"
      >
        {{ submitting() ? 'Sending…' : 'Send message' }}
        @if (!submitting()) {
          <app-icon name="arrowRight" svgClass="h-4 w-4" [strokeWidth]="2" />
        }
      </button>
    </form>
  }
</article>
